import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Button from 'components/atoms/Button';
import Heading from 'components/atoms/Heading';
import Paragraph from 'components/atoms/Paragraph';
import { ReactComponent as Grid } from 'assets/icons/grid.svg';
import { ReactComponent as List } from 'assets/icons/list.svg';
import { ReactComponent as Upload } from 'assets/icons/upload.svg';
import { ReactComponent as Search } from 'assets/icons/search.svg';

const Wrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  min-height: 64px;
  width: 100%;
  padding: 0 25px;
  background-color: ${({ theme }) => theme.gray4};
  border-bottom: 2px solid ${({ theme }) => theme.gray3};
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.gray3};
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.16);
  border-radius: 5px;
  overflow: hidden;

  :nth-of-type(2) {
    margin-left: 25px;
  }
`;

const UploadButton = styled.label`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  background-color: ${({ theme }) => theme.blue};
  height: 32px;
  border-radius: 5px;
  padding: 0 10px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.16);
  margin-right: 25px;
  text-decoration: none;

  :hover {
    background-color: ${({ theme }) => theme.blueHover};
    cursor: pointer;
  }

  svg {
    height: 24px;
    width: auto;
    fill: ${({ theme }) => theme.text};
    margin-right: 10px;
  }
`;

const SearchLabel = styled.label`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  background-color: ${({ theme }) => theme.gray3};
  height: 32px;
  width: 230px;
  border-radius: 5px;
  padding: 0 0 0 5px;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.16);
  overflow: hidden;
  transition: width 0.3s ease-in-out;

  :focus-within {
    background-color: ${({ theme }) => theme.gray2};
    width: 300px;
  }

  svg {
    height: 24px;
    width: auto;
    fill: ${({ theme }) => theme.textSecondary};
    margin-right: 5px;
  }
`;

const SearchInput = styled.input`
  border: none;
  height: 100%;
  width: 100%;
  background-color: transparent;
  color: ${({ theme }) => theme.text};
  font-size: ${({ theme }) => theme.body};
  font-family: 'Poppins', sans-serif;
  outline: none;

  ::placeholder {
    color: ${({ theme }) => theme.textSecondary};
    font-size: ${({ theme }) => theme.body};
    font-family: 'Poppins', sans-serif;
  }
`;

const Row = styled.div`
  display: flex;
`;

const StyledHeading = styled(Heading)`
  ::first-letter {
    text-transform: uppercase;
  }
`;

function Navbar({ isAdmin, currentPage, setIsGrid, isGrid, query, setQuery, navOnly }) {
  return (
    <Wrapper>
      <Row>
        <UploadButton as={Link} to="/zadania">
          <Paragraph>Zadania</Paragraph>
        </UploadButton>
        <UploadButton as={Link} to="/notatki">
          <Paragraph>Notatki</Paragraph>
        </UploadButton>
        {/* <UploadButton as={Link} to="/stream">
          <Paragraph>Stream</Paragraph>
        </UploadButton> */}
        {isAdmin ? (
          <UploadButton as={Link} to="/admin">
            <Paragraph>Panel</Paragraph>
          </UploadButton>
        ) : null}
        {!navOnly ? (
          <ButtonGroup>
            <Button type="button" isActive={isGrid} onClick={() => setIsGrid(true)}>
              <Grid />
            </Button>
            <Button type="button" border isActive={!isGrid} onClick={() => setIsGrid(false)}>
              <List />
            </Button>
          </ButtonGroup>
        ) : null}
      </Row>
      {!navOnly ? (
        <>
          <StyledHeading>{currentPage}</StyledHeading>
          <Row>
            <UploadButton as={Link} to="/przeslij">
              <Upload />
              <Paragraph>Prześlij</Paragraph>
            </UploadButton>
            <SearchLabel>
              <Search />
              <SearchInput
                type="text"
                placeholder="Szukaj"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
            </SearchLabel>
          </Row>
        </>
      ) : null}
    </Wrapper>
  );
}

Navbar.propTypes = {
  isAdmin: PropTypes.bool,
  currentPage: PropTypes.string.isRequired,
  setIsGrid: PropTypes.func.isRequired,
  setQuery: PropTypes.func.isRequired,
  isGrid: PropTypes.bool,
  query: PropTypes.string,
  navOnly: PropTypes.bool,
};

Navbar.defaultProps = {
  isAdmin: false,
  isGrid: false,
  query: '',
  navOnly: false,
};

export default Navbar;
